angular.module('bmsApp.resource')
	.controller('ResourceIndexCtrl', [
		'$state',
		'$window',
		'Upload',
		'$mdDialog',
		'notify',
		'ResourceSvc',
		'group',
		function ($state,
				  $window,
				  Upload,
				  $mdDialog,
				  notify,
				  ResourceSvc,
				  group) {

			var self = this;

			function init() {
				// open the root directory
				directoryOpen($state.params.directory);
			}

			function checkPinProtection(id, dir){
				if (dir && dir.pin_protection) {
					ResourceSvc.directory.pinVerificationDialog(dir)
						.then(function (pin) {
						if (pin) {
							directoryOpen(id, pin);
						}
						else{
							return;
						}
					});
				}
				else{
					directoryOpen(id);
				}
			}

			function directoryOpen(id, pin) {
				return ResourceSvc.directory.read({
					id: id,
					group: group,
					pin: pin
				})
					.then(function (response) {
						self.currentDir = self.tmpCurrentDir = response.data.current_directory;
						self.childDirs = self.tmpchildDirs = response.data.child_directory_collection;
						self.resources = self.tmpResources = response.data.resource_collection;
						// update the url - stay on the same state
						$state.go($state.current.name, {
							directory: (self.currentDir && self.currentDir.parent) ? self.currentDir.id : null
						}, {
							notify: false
						});

						return response;
					}, function (errors) {
						console.info('Failed to open directory');
						console.info(errors);
					});
			}

			function refreshCurrentDirectory() {
				directoryOpen($state.params.directory);
			}

			function resourceOpen(id) {
				$state.go('main.resource.read', {
					resourceId: id
				});
			}

			function resourceGetType(resource) {
				return ResourceSvc.resource.getType(resource);
			}

			function toggleSelect(item) {
				angular.forEach(self.childDirs, function (childDirItem) {
					if (childDirItem !== item) {
						childDirItem.selected = false;
					}
				});
				angular.forEach(self.resources, function (resourceItem) {
					if (resourceItem !== item) {
						resourceItem.selected = false;
					}
				});
				item.selected = !item.selected;
			}

			function onSearchFiles() {
				if (self.search.length) {
					let params = {
						search: self.search,
						group: self.group,
					};
					ResourceSvc.resource.resourceSearch(params)
						.then((response) => {
							self.childDirs = [];
							self.resources = response.data.resource_collection;
						});
				}
				else {
					self.currentDir = self.tmpCurrentDir;
					self.childDirs = self.tmpchildDirs;
					self.resources = self.tmpResources;
				}
			}

			function uploadFiles(files, directory) {
				if (group === 'my_files') {
					let currentDir;
					let directoryInput = null;
					if (directory) {
						currentDir = directory;
						directoryInput = {
							id: directory.id
						};
					}
					else if (self.currentDir) {
						currentDir = self.currentDir;
						directoryInput = {
							id: self.currentDir.id
						};
					}
					if (files && files.length) {
						if (currentDir.temporal && files.length > 1) {
							notify({
								message: 'You may only upload a single file at a time to this directory',
							});
							return;
						}
						for (let i = 0; i < files.length; i++) {
							let file = files[i];
							if (currentDir.temporal) {
								ResourceSvc.resource.startEndDialog(file, 'file')
									.then((response) => {
										uploadFile(file, directoryInput, response.startDate, response.endDate);
									}, (response) => {
										notify({
											message: 'File upload cancelled',
										});
									});

							}
							else {
								uploadFile(file, directoryInput);
							}

							function uploadFile(file, directoryInput, startDate, endDate) {
								let params = {
									file: file,
									directory: directoryInput,
								};
								if (startDate) {
									params.starts_at = startDate.format();
								}
								if (endDate) {
									params.ends_at = endDate.format();
								}
								Upload.upload({
									url: 'api/resource/resource/add',
									data: params,
								})
									.then(function (resp) {
										if (resp.data.success === true) {
											refreshCurrentDirectory();
										}
										else {
											console.info('Error status: ' + resp.data);
										}
									}, function (resp) {
										console.log('Error status: ' + resp.status);
									});
							}
						}
					}
				}
			}

			angular.extend(self, {
				group: group,
				methods: {
					init: init,
					directory: {
						open: directoryOpen,
						checkPinProtection: checkPinProtection,
					},
					resource: {
						open: resourceOpen,
						download: function (resource) {
							ResourceSvc.resource.download(resource);
						},
						getType: resourceGetType,
						searchFiles: onSearchFiles,
					},
					toggleSelect: toggleSelect,
					uploadFiles: uploadFiles
				},
				menus: {
					currentDir: function () {
						if (group === 'my_files') {
							return [
								{
									text: 'New folder...',
									click: function () {
										ResourceSvc.directory.createDialog(self.currentDir)
											.then(function () {
												refreshCurrentDirectory();
											});
									}
								}
							];
						}
						else {
							return [];
						}
					},
					childDir: function () {
						if (group === 'my_files') {
							return [
								{
									text: 'Move to...',
									click: function ($itemScope, $event, childDir) {
										ResourceSvc.directory.moveDialog(childDir)
											.then(function () {
												refreshCurrentDirectory();
											})
									},
									enabled: function ($itemScope, $event, childDir) {
										return childDir.locked === false;
									}
								},
								{
									text: 'Rename...',
									click: function ($itemScope, $event, childDir) {
										ResourceSvc.directory.updateDialog(childDir)
											.then(function () {
												refreshCurrentDirectory();
											});
									},
									enabled: function ($itemScope, $event, childDir) {
										return childDir.locked === false;
									}
								},
								null, // divider
								{
									text: 'Delete',
									click: function ($itemScope, $event, childDir) {
										ResourceSvc.directory.deleteDialog(childDir)
											.then(function () {
												refreshCurrentDirectory();
											})
									},
									enabled: function ($itemScope, $event, childDir) {
										return childDir.locked === false;
									}
								}
							];
						}
						else {
							return [];
						}
					},
					resource: function () {
						if (group === 'my_files') {
							return [
								{
									text: 'Move to...',
									click: function ($itemScope, $event, resource) {
										ResourceSvc.resource.moveDialog(resource)
											.then(function () {
												refreshCurrentDirectory();
											});
									},
									enabled: function ($itemScope, $event, resource) {
										return resource.locked === false;
									}
								},
								{
									text: 'Rename...',
									click: function ($itemScope, $event, resource) {
										ResourceSvc.resource.renameDialog(resource)
											.then(function () {
												refreshCurrentDirectory();
											})
									},
									enabled: function ($itemScope, $event, resource) {
										return resource.locked === false;
									}
								},
								{
									text: 'Edit start/end date...',
									click: function ($itemScope, $event, resource) {
										ResourceSvc.resource.startEndDialog(resource, 'resource')
											.then((response) => {
												ResourceSvc.resource.updateStartEnd({
													id: resource.id,
													starts_at: response.startDate,
													ends_at: response.endDate,
												})
													.then(() => {
														refreshCurrentDirectory();
													});
											});
									},
									enabled: function ($itemScope, $event, resource) {
										return resource.locked === false;
									},
									displayed: function ($itemScope, $event, resource) {
										return self.currentDir.temporal;
									},
								},
								null, // divider
								{
									text: 'Download',
									click: function ($itemScope, $event, resource) {
										ResourceSvc.resource.download(resource);
									}
								},
								{
									text: function ($itemScope, $event, resource) {
										return resource.envelope && resource.envelope.awaiting_signature ? 'Sign...' : 'Sign (' + resource.envelope.status + ')';
									},
									click: function ($itemScope, $event, resource) {
										resource.generatingSignableUrl = true;
										ResourceSvc.resource.generateSigningUrl(resource)
											.then(function (response) {
												resource.generatingSignableUrl = false;
												$window.location.href = response.data.signingUrl;
											});
									},
									enabled: function ($itemScope, $event, resource) {
										return resource.envelope && resource.envelope.awaiting_signature && !resource.generatingSignableUrl;
									},
									displayed: function ($itemScope, $event, resource) {
										return resource.envelope !== null;
									}
								},
								null, // divider
								{
									text: 'Delete',
									click: function ($itemScope, $event, resource) {
										ResourceSvc.resource.deleteDialog(resource)
											.then(function () {
												refreshCurrentDirectory();
											})
									},
									enabled: function ($itemScope, $event, resource) {
										return resource.locked === false;
									}
								}
							];
						}
						else {
							return [];
						}
					}
				}
			});

		}
	]);


